import { defineStore } from 'pinia'

export const usePreviewStore = defineStore('previewStore', () => {
  const isPreview = ref(false)
  const token = ref('')
  const route = useRoute()
  const { $apiBOF } = useNuxtApp()

  const fetch = async () => {
    const accessToken = route.query.accessToken as string
    const id = route.query.id as string

    if (!accessToken || !id) {
      isPreview.value = false
      token.value = ''
      return
    }

    token.value = accessToken
    isPreview.value = true

    try {
      await $apiBOF('/auth/new-token', {
        method: 'POST',
      })
    } catch {
      // Keep preview mode active so preview URLs fetch the draft by id instead of /articles/preview.
    } finally {
      update({
        isPreview: isPreview.value,
        token: token.value,
      })
    }
  }

  const update = (payload: { isPreview: boolean; token: string }) => {
    isPreview.value = payload.isPreview
    token.value = payload.token
  }

  return {
    isPreview,
    token,
    fetch,
    update,
  }
})
